import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/t_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-12c537f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt-2 d-flex flex-fill justify-content-center flex-column"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "img-fluid"
  })
], -1))
const _hoisted_3 = { class: "text-center fs-1 fw-bold mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "text-primary mt-5 d-flex align-self-center flex-column fs-4"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 1,
  class: "text-danger mt-5 d-flex align-self-center fs-4"
}
const _hoisted_10 = {
  key: 2,
  class: "text-danger mt-5 d-flex align-self-center fs-4"
}
const _hoisted_11 = {
  key: 3,
  class: "mb-3 d-flex align-self-center fs-4"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "mt-2 d-flex flex-fill justify-content-center" }
const _hoisted_14 = {
  class: "container",
  style: {"max-width":"800px"}
}
const _hoisted_15 = {
  key: 0,
  class: "card card-body bg-light align-self-center p-5 mb-0"
}
const _hoisted_16 = { class: "row mb-sm-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label col-sm-4" }, "ログインID（メールアドレス）", -1))
const _hoisted_18 = { class: "col-sm-8" }
const _hoisted_19 = { class: "row mb-sm-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label col-sm-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge bg-danger me-2" }, "必須"),
  /*#__PURE__*/_createTextVNode("パスワード")
], -1))
const _hoisted_21 = { class: "col-sm-8" }
const _hoisted_22 = { class: "input-group" }
const _hoisted_23 = ["type"]
const _hoisted_24 = {
  class: "fs-6 position-absolute w-100 text-primary",
  style: {"left":"0px","top":"-8px"}
}
const _hoisted_25 = { class: "badge bg-primary" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-sm-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-8 offset-sm-4" }, [
    /*#__PURE__*/_createTextVNode(" 8～32文字で入力してください。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 英文字(大文字、小文字)、数字、記号の2種類以上で作成してください。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" ※使用可能な記号  ! # $ % & / = ? @ ")
  ])
], -1))
const _hoisted_27 = { class: "row mb-sm-2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "col-form-label col-sm-4" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "badge bg-danger me-2" }, "必須"),
  /*#__PURE__*/_createTextVNode("パスワード（確認用）")
], -1))
const _hoisted_29 = { class: "col-sm-8" }
const _hoisted_30 = { class: "input-group" }
const _hoisted_31 = ["type"]
const _hoisted_32 = {
  class: "fs-6 position-absolute w-100 text-primary",
  style: {"left":"0px","top":"-8px"}
}
const _hoisted_33 = { class: "badge bg-primary" }
const _hoisted_34 = {
  key: 1,
  class: "ps-5 pe-5"
}
const _hoisted_35 = { class: "row mt-3" }
const _hoisted_36 = { class: "col-sm-8 offset-sm-4" }
const _hoisted_37 = { class: "d-flex" }
const _hoisted_38 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa = _resolveComponent("fa")!

  return (_ctx.ready)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
        (_ctx.reseted)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createTextVNode(" パスワードを再設定しました。 "),
              _hoisted_5,
              _createTextVNode(" 下記よりログインしてください。"),
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("a", { href: _ctx.loginPath }, "日本歯科衛生協会 Webユーザーサイトログイン", 8, _hoisted_8)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.loginId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 不正なURLであるため処理できません。 "))
          : _createCommentVNode("", true),
        (_ctx.timeout)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, " 有効期限切れのURLであるため処理できません。 "))
          : _createCommentVNode("", true),
        (!_ctx.alreadyResetd && _ctx.loginId && !_ctx.reseted && !_ctx.timeout)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createTextVNode(" パスワードの再設定を行います。"),
              _hoisted_12,
              _createTextVNode(" 新しいパスワードを入力してください。 ")
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            (!_ctx.alreadyResetd && _ctx.loginId && !_ctx.reseted && !_ctx.timeout)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginId) = $event)),
                        class: "form-control bg-light form-control-lg",
                        readonly: "true"
                      }, null, 512), [
                        [_vModelText, _ctx.loginId]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _withDirectives(_createElementVNode("input", {
                          type: _ctx.showPassword ? 'type' :'password',
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                          class: "form-control form-control-lg",
                          style: _normalizeStyle({'background-color': !_ctx.password ? '' : (_ctx.validPassword ? 'aquamarine' : 'lightpink')}),
                          maxlength: "32"
                        }, null, 12, _hoisted_23), [
                          [_vModelDynamic, _ctx.password]
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-lg border-start-0 bg-white",
                          style: {"border-color":"lightgray"},
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPassword=!_ctx.showPassword))
                        }, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.showPassword ? '非表示' : '表示'), 1)
                          ]),
                          _createVNode(_component_fa, {
                            class: "me-1 text-primary",
                            icon: _ctx.showPassword ? 'eye-slash' : 'eye'
                          }, null, 8, ["icon"])
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _withDirectives(_createElementVNode("input", {
                          onPaste: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
                          type: _ctx.showPassword ? 'type' :'password',
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                          class: "form-control form-control-lg",
                          style: _normalizeStyle({'background-color': !_ctx.confirmPassword ? '' : ((_ctx.password===_ctx.confirmPassword) ? 'aquamarine' : 'lightpink')}),
                          maxlength: "32"
                        }, null, 44, _hoisted_31), [
                          [_vModelDynamic, _ctx.confirmPassword]
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-lg border-start-0 bg-white",
                          style: {"border-color":"lightgray"},
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showPassword=!_ctx.showPassword))
                        }, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.showPassword ? '非表示' : '表示'), 1)
                          ]),
                          _createVNode(_component_fa, {
                            class: "me-1 text-primary",
                            icon: _ctx.showPassword ? 'eye-slash' : 'eye'
                          }, null, 8, ["icon"])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.alreadyResetd && _ctx.loginId && !_ctx.reseted && !_ctx.timeout)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("button", {
                          ref: "resetPasswordButton",
                          class: "btn btn-lg btn-primary text-white flex-fill",
                          disabled: !_ctx.canReset,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.resetPassword()))
                        }, [
                          _createVNode(_component_fa, {
                            class: "me-1",
                            icon: "rotate-right"
                          }),
                          _createTextVNode("再設定する")
                        ], 8, _hoisted_38)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}